var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinfra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 10.5996C0.664062 5.07676 5.14121 0.599609 10.6641 0.599609H38.6641C44.1869 0.599609 48.6641 5.07676 48.6641 10.5996V38.5996C48.6641 44.1225 44.1869 48.5996 38.6641 48.5996H10.6641C5.14121 48.5996 0.664062 44.1225 0.664062 38.5996V10.5996Z",
    fill: "url(#paint0_linear_4168_5818)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6641 19.5996H34.6641V25.5996",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6641 19.5996L26.1641 28.0996L21.1641 23.0996L14.6641 29.5996",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5818",
    x1: 24.6641,
    y1: 0.599609,
    x2: 24.6641,
    y2: 48.5996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinfra);
export default __webpack_public_path__ + "static/media/Finfra.83629a48acd90de2a97b3ebb45f13c3c.svg";
export { ForwardRef as ReactComponent };